import { render, staticRenderFns } from "./ProfileChangeDarkmode.vue?vue&type=template&id=ca04926c&scoped=true"
import script from "./ProfileChangeDarkmode.vue?vue&type=script&lang=js"
export * from "./ProfileChangeDarkmode.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeDarkmode.vue?vue&type=style&index=0&id=ca04926c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca04926c",
  null
  
)

export default component.exports